module.exports = __webpack_public_path__ + "static/media/fondo2.469804d3.jpg";